var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'ability-question-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      questions: '',
      searchTitle: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (addSearch) {
      let data = {
        search_title: this.searchTitle
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }
      this.$store.dispatch('GET_ABILITY_QUESTION_LIST', { data: data })
      .then(res => {
        if (addSearch) {
          this.questions = this.questions.concat(res.questions.data)
        } else {
          this.questions = res.questions.data
          this.searchEnd = true
        }
        this.nextExist = res.next_exist
      })
      .catch(err => console.log(err))
    },
    goQuestionNew: function () {
      this.$router.push({ path: '/ability_question/new' })
    },
    goQuestionEdit: function (questionId, isBeforeNotificationStart) {
      if (isBeforeNotificationStart === 1) {
        window.alert('この評価は未公開の能力評価の評価項目に設定されています。\n編集を行うと評価項目が変わります。')
      }
      this.$router.push({ path: '/ability_question/' + questionId + '/edit' })
    },
    goQuestionDetail: function (questionId) {
      this.$router.push({ path: '/ability_question/' + questionId })
    },
    questionDelete: function (questionId, isUseUsertype) {
      if (isUseUsertype === 1) {
        window.alert('この評価は役職マスターに設定されています。\n削除を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        if (window.confirm(this.$t('Delete Confirm'))) {
          this.$store.dispatch('ABILITY_QUESTION_DELETE', {
            data: {
              id: questionId
            }
          })
          .then(res => {
            this.search()
          })
          .catch(err => console.log(err))
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/ability-question-list.js